module.exports = __webpack_public_path__ + "h5/img/judgeBit.8155ccd9.png";